import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { setBreadcrumbs } from "../redux/slices/breadcrumbSlice";

export const useBreadcrumb = (bc = [], dependencies = []) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setBreadcrumbs(bc));
  }, [...dependencies, location.pathname]);
};
